enum PlaneusSystems {
  DEMO = "DEMOSYSTEM",
  TEST = "TESTSYSTEM",
  SALES = "SALESSYSTEM",
  TECDEMO = "TECDEMOSYSTEM",
}

export const API_SERVER: string = window.planeusConfig?.api
export const API_SERVER_DOC = API_SERVER
export const API_SERVER_USER = API_SERVER
export const API_SERVER_BASEDATA = API_SERVER
export const API_SERVER_PLANNING_PROCESS = API_SERVER
export const API_SERVER_NOTIFICATIONS = `${API_SERVER}/notification`
export const API_SERVER_NOTIFICATIONS_RECEIVE_ONLY = ""

export const IS_TEST_SYSTEM = window.planeusConfig?.environment === PlaneusSystems.TEST
export const IS_DEMO_SYSTEM = window.planeusConfig?.environment === PlaneusSystems.DEMO
export const IS_SALES_SYSTEM = window.planeusConfig?.environment === PlaneusSystems.SALES
export const IS_TEC_DEMO_SYSTEM = window.planeusConfig?.environment === PlaneusSystems.TECDEMO
